import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useScrollTo } from "./scroll";
import { CONTACT, FOOTER_SOLUTIONS, FOOTER_COMPANY } from "../../data/content";
import { openDemoChooser } from "./DemoBookingModal";

export default function Footer() {
  const scrollToId = useScrollTo();
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-ajmus-ink text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div className="lg:col-span-1">
            <div className="inline-flex rounded-2xl bg-white px-3 py-2 shadow-sm">
              <img
                src="/brand/ajmus-logo.png"
                alt="AJMUS"
                className="h-9 w-auto max-w-[145px] object-contain"
              />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              AJMUS builds connected management software for healthcare organisations and
              educational institutions.
            </p>
          </div>

          {/* solutions */}
          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.24em] text-white/40">Solutions</h4>
            <ul className="mt-5 space-y-3">
              {FOOTER_SOLUTIONS.map((s) => (
                <li key={s}>
                  <button
                    onClick={() => scrollToId("healthcare")}
                    data-testid={`footer-solution-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-white/65 transition-colors duration-200 hover:text-white"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* company */}
          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.24em] text-white/40">Company</h4>
            <ul className="mt-5 space-y-3">
              {FOOTER_COMPANY.map((c, i) => (
                <li key={`${c.label}-${i}`}>
                  <button
                    onClick={() => c.label === "Live Demo" ? openDemoChooser() : scrollToId(c.id)}
                    data-testid={`footer-company-${i}`}
                    className="text-sm text-white/65 transition-colors duration-200 hover:text-white"
                  >
                    {c.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.24em] text-white/40">Contact</h4>
            <ul className="mt-5 space-y-3.5">
              <li className="flex items-center gap-2.5 text-sm text-white/65">
                <Mail size={15} className="text-health-soft" /> {CONTACT.email}
              </li>
              <li className="flex items-center gap-2.5 text-sm text-white/65">
                <Phone size={15} className="text-health-soft" /> {CONTACT.phone}
              </li>
              <li className="flex items-start gap-2.5 text-sm text-white/65">
                <MapPin size={15} className="mt-0.5 text-health-soft" /> {CONTACT.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 sm:flex-row sm:items-center">
          <p className="text-xs text-white/45">© {year} AJMUS. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <button data-testid="footer-privacy" className="text-xs text-white/45 transition-colors hover:text-white/80">
              Privacy Policy
            </button>
            <button data-testid="footer-terms" className="text-xs text-white/45 transition-colors hover:text-white/80">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
